import React, { useState } from 'react';
import Sidebar from 'components/ui/Sidebar';
import Icon from 'components/AppIcon';

const LawyerProfile = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [isEditing, setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState({
    personalInfo: {
      name: 'Advocate Sarah Wanjiku',
      email: 'sarah.wanjiku@lawdesk.ke',
      phone: '+254 712 345 678',
      lskNumber: 'LSK/001234/2010',
      admissionDate: '2010-03-15',
      county: 'Nairobi',
      city: 'Nairobi',
      profileImage: 'https://randomuser.me/api/portraits/women/42.jpg'
    },
    professionalInfo: {
      specializations: ['Family Law', 'Criminal Law', 'Property Law'],
      experience: 14,
      education: [
        { degree: 'LLB', institution: 'University of Nairobi', year: '2008' },
        { degree: 'Diploma in Law', institution: 'Kenya School of Law', year: '2009' }
      ],
      certifications: ['LSK Member', 'Family Law Specialist', 'Mediator Certified'],
      languages: ['English', 'Swahili', 'Kikuyu'],
      courtAdmissions: ['High Court of Kenya', 'Court of Appeal', 'Supreme Court']
    },
    practiceInfo: {
      firmName: 'Wanjiku & Associates Advocates',
      practiceAreas: ['Family Law', 'Criminal Defense', 'Property Disputes', 'Civil Litigation'],
      fees: {
        consultation: 5000,
        hourlyRate: 15000,
        retainer: 50000
      },
      availability: {
        schedule: 'Monday - Friday: 8:00 AM - 6:00 PM',
        responseTime: 'Within 2 hours',
        urgentCases: true
      },
      officeLocation: {
        address: 'Westlands, Nairobi',
        building: 'Westlands Office Park, 5th Floor',
        coordinates: { lat: -1.2638, lng: 36.8047 }
      }
    },
    stats: {
      totalCases: 247,
      activeCases: 18,
      successRate: 92,
      clientSatisfaction: 4.9,
      reviews: 127,
      avgResponseTime: '1.5 hours'
    },
    clientMatching: {
      availableForMatching: true,
      maxNewClients: 5,
      preferredCaseTypes: ['Family Law', 'Property Law'],
      minCaseBudget: 25000,
      emergencyAvailability: true
    }
  });

  const handleInputChange = (section, field, value) => {
    setProfileData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  const handleSave = () => {
    setIsEditing(false);
    // Save to API
    console.log('Saving profile data:', profileData);
  };

  const tabs = [
    { id: 'overview', label: 'Overview', icon: 'User' },
    { id: 'professional', label: 'Professional Info', icon: 'Briefcase' },
    { id: 'practice', label: 'Practice Details', icon: 'Building' },
    { id: 'matching', label: 'Client Matching', icon: 'Users' },
    { id: 'statistics', label: 'Performance', icon: 'TrendingUp' }
  ];

  const renderOverview = () => (
    <div className="space-y-6">
      <div className="bg-surface rounded-lg p-6">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-heading font-semibold text-text-primary">Personal Information</h3>
          <button
            onClick={() => setIsEditing(!isEditing)}
            className="flex items-center space-x-2 px-4 py-2 text-primary border border-primary rounded-lg hover:bg-primary-50 transition-smooth"
          >
            <Icon name={isEditing ? 'X' : 'Edit'} size={16} />
            <span>{isEditing ? 'Cancel' : 'Edit'}</span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="md:col-span-2 flex items-center space-x-6">
            <img 
              src={profileData?.personalInfo?.profileImage} 
              alt="Profile"
              className="w-24 h-24 rounded-full object-cover"
            />
            <div>
              <h2 className="text-2xl font-heading font-bold text-text-primary mb-1">
                {profileData?.personalInfo?.name}
              </h2>
              <p className="text-text-secondary mb-2">{profileData?.professionalInfo?.specializations?.join(', ')}</p>
              <div className="flex items-center space-x-4 text-sm text-text-secondary">
                <span>{profileData?.professionalInfo?.experience} years experience</span>
                <span>•</span>
                <span>LSK #{profileData?.personalInfo?.lskNumber}</span>
              </div>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Email</label>
            <input
              type="email"
              value={profileData?.personalInfo?.email}
              onChange={(e) => handleInputChange('personalInfo', 'email', e.target?.value)}
              disabled={!isEditing}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-secondary-50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Phone</label>
            <input
              type="tel"
              value={profileData?.personalInfo?.phone}
              onChange={(e) => handleInputChange('personalInfo', 'phone', e.target?.value)}
              disabled={!isEditing}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-secondary-50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">County</label>
            <input
              type="text"
              value={profileData?.personalInfo?.county}
              onChange={(e) => handleInputChange('personalInfo', 'county', e.target?.value)}
              disabled={!isEditing}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-secondary-50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">LSK Number</label>
            <input
              type="text"
              value={profileData?.personalInfo?.lskNumber}
              onChange={(e) => handleInputChange('personalInfo', 'lskNumber', e.target?.value)}
              disabled={!isEditing}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-secondary-50"
            />
          </div>
        </div>

        {isEditing && (
          <div className="mt-6 flex justify-end space-x-3">
            <button
              onClick={() => setIsEditing(false)}
              className="px-4 py-2 text-text-secondary border border-border rounded-lg hover:bg-secondary-50 transition-smooth"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-700 transition-smooth"
            >
              Save Changes
            </button>
          </div>
        )}
      </div>
    </div>
  );

  const renderProfessional = () => (
    <div className="space-y-6">
      <div className="bg-surface rounded-lg p-6">
        <h3 className="text-xl font-heading font-semibold text-text-primary mb-6">Professional Information</h3>
        
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Specializations</label>
            <div className="flex flex-wrap gap-2">
              {profileData?.professionalInfo?.specializations?.map((spec, index) => (
                <span key={index} className="px-3 py-1 bg-primary-50 text-primary rounded-full text-sm">
                  {spec}
                </span>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Education</label>
            <div className="space-y-3">
              {profileData?.professionalInfo?.education?.map((edu, index) => (
                <div key={index} className="flex items-center justify-between p-3 border border-border rounded-lg">
                  <div>
                    <h4 className="font-medium text-text-primary">{edu?.degree}</h4>
                    <p className="text-sm text-text-secondary">{edu?.institution}</p>
                  </div>
                  <span className="text-sm text-text-secondary">{edu?.year}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Languages</label>
            <div className="flex flex-wrap gap-2">
              {profileData?.professionalInfo?.languages?.map((lang, index) => (
                <span key={index} className="px-3 py-1 bg-secondary-100 text-text-primary rounded-full text-sm">
                  {lang}
                </span>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Court Admissions</label>
            <div className="space-y-2">
              {profileData?.professionalInfo?.courtAdmissions?.map((court, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={16} className="text-success" />
                  <span className="text-sm text-text-primary">{court}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderPractice = () => (
    <div className="space-y-6">
      <div className="bg-surface rounded-lg p-6">
        <h3 className="text-xl font-heading font-semibold text-text-primary mb-6">Practice Details</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Firm Name</label>
            <input
              type="text"
              value={profileData?.practiceInfo?.firmName}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Office Address</label>
            <input
              type="text"
              value={profileData?.practiceInfo?.officeLocation?.address}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Consultation Fee (KES)</label>
            <input
              type="number"
              value={profileData?.practiceInfo?.fees?.consultation}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Hourly Rate (KES)</label>
            <input
              type="number"
              value={profileData?.practiceInfo?.fees?.hourlyRate}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-text-primary mb-2">Practice Areas</label>
            <div className="flex flex-wrap gap-2">
              {profileData?.practiceInfo?.practiceAreas?.map((area, index) => (
                <span key={index} className="px-3 py-1 bg-primary-50 text-primary rounded-full text-sm">
                  {area}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-text-primary mb-2">Office Schedule</label>
            <input
              type="text"
              value={profileData?.practiceInfo?.availability?.schedule}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
        </div>
      </div>
    </div>
  );

  const renderMatching = () => (
    <div className="space-y-6">
      <div className="bg-surface rounded-lg p-6">
        <h3 className="text-xl font-heading font-semibold text-text-primary mb-6">Client Matching Settings</h3>
        
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="font-medium text-text-primary">Available for New Clients</h4>
              <p className="text-sm text-text-secondary">Allow new clients to find and contact you</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={profileData?.clientMatching?.availableForMatching}
                onChange={(e) => handleInputChange('clientMatching', 'availableForMatching', e.target?.checked)}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
            </label>
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Maximum New Clients Per Month</label>
            <input
              type="number"
              value={profileData?.clientMatching?.maxNewClients}
              onChange={(e) => handleInputChange('clientMatching', 'maxNewClients', parseInt(e.target?.value))}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Preferred Case Types</label>
            <div className="flex flex-wrap gap-2">
              {profileData?.clientMatching?.preferredCaseTypes?.map((type, index) => (
                <span key={index} className="px-3 py-1 bg-primary-50 text-primary rounded-full text-sm">
                  {type}
                </span>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">Minimum Case Budget (KES)</label>
            <input
              type="number"
              value={profileData?.clientMatching?.minCaseBudget}
              onChange={(e) => handleInputChange('clientMatching', 'minCaseBudget', parseInt(e.target?.value))}
              className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <div className="flex items-center justify-between">
            <div>
              <h4 className="font-medium text-text-primary">Emergency Availability</h4>
              <p className="text-sm text-text-secondary">Accept urgent cases outside normal hours</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={profileData?.clientMatching?.emergencyAvailability}
                onChange={(e) => handleInputChange('clientMatching', 'emergencyAvailability', e.target?.checked)}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );

  const renderStatistics = () => (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-surface rounded-lg p-6">
          <div className="flex items-center justify-between mb-2">
            <Icon name="Briefcase" size={24} className="text-primary" />
            <span className="text-2xl font-bold text-text-primary">{profileData?.stats?.totalCases}</span>
          </div>
          <p className="text-sm text-text-secondary">Total Cases</p>
        </div>

        <div className="bg-surface rounded-lg p-6">
          <div className="flex items-center justify-between mb-2">
            <Icon name="Clock" size={24} className="text-warning-600" />
            <span className="text-2xl font-bold text-text-primary">{profileData?.stats?.activeCases}</span>
          </div>
          <p className="text-sm text-text-secondary">Active Cases</p>
        </div>

        <div className="bg-surface rounded-lg p-6">
          <div className="flex items-center justify-between mb-2">
            <Icon name="TrendingUp" size={24} className="text-success" />
            <span className="text-2xl font-bold text-text-primary">{profileData?.stats?.successRate}%</span>
          </div>
          <p className="text-sm text-text-secondary">Success Rate</p>
        </div>

        <div className="bg-surface rounded-lg p-6">
          <div className="flex items-center justify-between mb-2">
            <Icon name="Star" size={24} className="text-warning-500" />
            <span className="text-2xl font-bold text-text-primary">{profileData?.stats?.clientSatisfaction}</span>
          </div>
          <p className="text-sm text-text-secondary">Client Rating</p>
        </div>
      </div>

      <div className="bg-surface rounded-lg p-6">
        <h3 className="text-xl font-heading font-semibold text-text-primary mb-6">Performance Metrics</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h4 className="font-medium text-text-primary mb-2">Response Time</h4>
            <p className="text-3xl font-bold text-success mb-1">{profileData?.stats?.avgResponseTime}</p>
            <p className="text-sm text-text-secondary">Average response time</p>
          </div>

          <div>
            <h4 className="font-medium text-text-primary mb-2">Client Reviews</h4>
            <p className="text-3xl font-bold text-warning-600 mb-1">{profileData?.stats?.reviews}</p>
            <p className="text-sm text-text-secondary">Total reviews received</p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      
      <div className="md:ml-64 transition-layout">
        {/* Header */}
        <header className="bg-surface border-b border-border px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-heading font-bold text-text-primary">My Profile</h1>
              <p className="text-text-secondary mt-1">Manage your professional profile and settings</p>
            </div>
            <div className="flex items-center space-x-4">
              <button className="text-text-secondary hover:text-text-primary transition-smooth">
                <Icon name="Settings" size={20} />
              </button>
            </div>
          </div>
        </header>

        {/* Tabs */}
        <div className="border-b border-border px-6">
          <nav className="flex space-x-8">
            {tabs?.map(tab => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-smooth ${
                  activeTab === tab?.id
                    ? 'border-primary text-primary' :'border-transparent text-text-secondary hover:text-text-primary'
                }`}
              >
                <Icon name={tab?.icon} size={16} />
                <span>{tab?.label}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Content */}
        <main className="p-6">
          {activeTab === 'overview' && renderOverview()}
          {activeTab === 'professional' && renderProfessional()}
          {activeTab === 'practice' && renderPractice()}
          {activeTab === 'matching' && renderMatching()}
          {activeTab === 'statistics' && renderStatistics()}
        </main>
      </div>
    </div>
  );
};

export default LawyerProfile;